import type { OpenDetailsPayload, OpenDetails } from './typings'

export const openDetailsActionCreator = (
  payload: OpenDetailsPayload,
): OpenDetails => ({ type: 'activities/openDetails', payload })
